module.exports = __webpack_public_path__ + "images/cfea48c7072a296a2e030511707cfe52-COSTA-MUJERES-WHITE.png";